import { __awaiter } from "tslib";
import { useMST } from '@hooks/MSTHook';
import AppDispatcher from '@reducers/app/dispatcher';
import CompanyDispatcher from '@reducers/company/dispatcher';
import { selectCurrentCompanyKey } from '@reducers/company/selectors';
import ContactDispatcher from '@reducers/contact/dispatcher';
import FlagsDispatcher from '@reducers/flags/dispatcher';
import { useAppDispatch } from '@reducers/index';
import { actions as searchCompanyActions } from '@reducers/searchCompany/reducer';
import SettingsDispatcher from '@reducers/settings/dispatcher';
import { store } from '@reducers/store';
import dayjs from 'dayjs';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useAsyncFetch } from 'react-hooks-async-handlers';
import { messaging } from './lib/messaging';
function AppInt(props) {
    const { children } = props;
    const { initMobx, root } = useMST(mstStore => ({
        root: mstStore,
        initMobx: mstStore.init,
    }));
    const dispatch = useAppDispatch();
    useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(AppDispatcher.install());
    }));
    useEffect(() => {
        initMobx();
    }, []);
    useEffect(() => {
        function onMessage(event) {
            var _a, _b, _c;
            if (!_.isObject(event.data))
                return null;
            const { type, payload } = event.data;
            console.log(dayjs().toISOString(), 'received event', type, payload, event);
            switch (type) {
                case 'SETTINGS': {
                    dispatch(SettingsDispatcher.load(payload));
                    break;
                }
                case 'PAGE': {
                    dispatch(AppDispatcher.setPage(payload));
                    break;
                }
                case 'FLAG/PULL': {
                    dispatch(FlagsDispatcher.set(payload));
                    break;
                }
                case 'PARSER/RESULT': {
                    const result = payload || {};
                    dispatch(AppDispatcher.actions.setParserResult(result));
                    break;
                }
                case 'SEARCH/RESULT': {
                    const { parser, result, type } = payload || {};
                    // dispatch(AppDispatcher.actions.setParserResult(parser))
                    const app = root.app;
                    if (type === 'contact') {
                        dispatch(ContactDispatcher.setSearchResult(result));
                    }
                    if (type === 'company') {
                        app.setSearchMetadataResult(result);
                        if (result) {
                            const appContext = store.getState().app.appContext;
                            const previousCompanyKey = selectCurrentCompanyKey(store.getState());
                            dispatch(CompanyDispatcher.setSearchEmployeesResult(result));
                            const companyKey = ((_b = (_a = result.company) === null || _a === void 0 ? void 0 : _a.company_lid) === null || _b === void 0 ? void 0 : _b.toString()) || ((_c = result.company) === null || _c === void 0 ? void 0 : _c.fqdn);
                            if (companyKey && previousCompanyKey && previousCompanyKey !== companyKey) {
                                app.setFirstSearch(true);
                            }
                            if (!_.isEmpty(result.company)) {
                                app.setUniqueSearchId((result === null || result === void 0 ? void 0 : result.requestId) || '');
                                dispatch(searchCompanyActions.setResultCompany({ context: appContext, company: result.company }));
                            }
                            // The employees themselves are stored by `setSearchEmployeesResult` above.
                            if (!_.isEmpty(result.contacts) && app.firstSearch) {
                                app.setShowEmployeesCounterBadge(true);
                            }
                        }
                    }
                    break;
                }
                case 'CONTENT/READY': {
                    dispatch(AppDispatcher.actions.setIsContentScriptReady());
                    break;
                }
                default:
                    break;
            }
        }
        window.addEventListener('message', onMessage, false);
        messaging.sendMessage('APP_INIT');
        messaging.sendMessage('SETTINGS_READY'); // support for plugin 10.5+
        return () => {
            // doesn't suppose to happen, but there is bug with 2 mounts
            window.removeEventListener('message', onMessage);
        };
    }, [root]);
    // avoid crashes
    if (!root.isInitialized)
        return null;
    return children;
}
export default observer(AppInt);
